<template>
  <main class="container-sales-point">
    <sidebar class="sidebar__sales-point">
      <div class="sidebar__search-engine">
        <v-text class="headline onSurface--text font-weight-bold text-uppercase mb-2 pl-3">
          Puntos de venta
        </v-text>
        <v-divider></v-divider>
        <!--  <v-text-field hide-actions outlined chips clearable small-chips prepend-inner-icon="location_searching"
          label="Buscar por ciudad o dirección" v-model="keyPuntoventas">
        </v-text-field> -->
      </div>
      <div class="sidebar__point">
        <!-- Lista Mobile -->
        <v-virtual-scroll v-if="$vuetify.breakpoint.smAndDown" ref="virtualScroll" class="point__vScroll"
          :items="points" :item-height="155" height="400">
          <template v-slot:default="{ item: point, index }">
            <v-list-item :key="index" @click="selectPoint(index)">
              <v-list-item-content class="my-0">
                <v-card outlined class="py-0 card-hover">
                  <v-card-text class="sidebar__point--text">
                    <article class="d-flex flex-column flex-nowrap">
                      <v-text class="title onSurface--text font-weight-bold text-capitalize">
                        {{ point.nombre }}
                      </v-text>
                      <v-text class=" subtitle-1 text-capitalize">{{ point.descripcion }} </v-text>
                    </article>
                    <article class="font-weight-bold"> Dirección:
                      <span class="font-weight-regular">
                        {{ point.direccion }}
                      </span>
                    </article>
                    <article class="font-weight-bold"> Horario:
                      <span class="font-weight-regular">
                        {{ point.horario }} | {{ point.horario_atencion }}
                      </span>
                    </article>
                  </v-card-text>
                </v-card>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-virtual-scroll>
        <!-- Lista Escritorio -->
        <v-virtual-scroll v-else ref="virtualScroll" class="point__vScroll" :items="points" :item-min-height="175"
          :item-height="185" height="650">
          <template v-slot:default="{ item: point, index }">
            <v-list-item :key="index" @click="selectPoint(index)">
              <v-list-item-content class="my-0">
                <v-card outlined class="py-0 card-hover">
                  <v-card-text class="sidebar__point--text">
                    <article class="d-flex flex-column">
                      <v-text
                        class="d-inline-block text-truncate title onSurface--text font-weight-bold text-capitalize mb-2">
                        {{ point.nombre }}
                      </v-text>
                      <v-text class=" body-1 text-capitalize">{{ point.descripcion }} </v-text>
                    </article>
                    <article class="font-weight-bold"> Dirección:
                      <span class="font-weight-regular">
                        {{ point.direccion }}
                      </span>
                    </article>
                    <article class="font-weight-bold"> Horario:
                      <span class="font-weight-regular">
                        {{ point.horario }} | {{ point.horario_atencion }}
                      </span>
                    </article>
                  </v-card-text>
                </v-card>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </div>
    </sidebar>
    <div class="map-sales-point">
      <!-- Pasar el punto seleccionado al mapa -->
      <GoogleMap :points="points" :selectedPoint="selectedPoint" :key="points" />
    </div>
  </main>
</template>

<script>
import GoogleMap from './GoogleMap.vue';
import axios from 'axios';
import { configApi } from '../api/configApi';
import { headers } from '../api/headers';

export default {
  components: {
    GoogleMap,
  },
  name: "puntosVenta",
  data() {
    return {
      points: '',
      keyPuntoventas: '',
      selectedPoint: null, // Mantendrá el punto seleccionado
    };
  },
  async created() {
    await axios.get(`${configApi.apiUrl}ver_punto_ventas_mapa`, null, { headers }).then((response) => {
      this.points = response.data.data;
      this.$nextTick(() => {
        if (this.$refs.virtualScroll) {
          this.$refs.virtualScroll.updateVisibleItems();
        }
      });
    });
  },
  methods: {
    selectPoint(index) {
      // Establecer el punto seleccionado basado en el índice
      this.selectedPoint = this.points[index];
    },
  },
};
</script>

<style>
.container-sales-point {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 0.1fr 0.8fr 0.3fr;
  grid-auto-columns: 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "."
    "sidebar__sales-point"
    "map-sales-point";
}

.sidebar__sales-point {
  grid-area: sidebar__sales-point;


}



.card-hover:hover {
  border: 1.3px solid #715D00;

}

.map-sales-point {
  grid-area: map-sales-point;
}

@media (min-width: 960px) {
  .container-sales-point {
    display: grid;
    grid-template-columns: 0.6fr 1.4fr;
    grid-template-rows: 0.1fr 0.8fr 0.1fr;
    gap: 0px 0px;
    grid-auto-flow: row;
    grid-template-areas:
      ". ."
      "sidebar__sales-point map-sales-point"
      ". .";
    height: 100vh;
  }

  .sidebar__sales-point {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: min-content 1.7fr;
    gap: 0px 0px;
    grid-auto-flow: row;
    grid-template-areas:
      "sidebar__search-engine"
      "sidebar__point";
    grid-area: sidebar__sales-point;
    overflow: hidden;


  }





  .sidebar__point {
    grid-area: sidebar__point;
  }

  .sidebar__point--text>p {
    padding: 0rem;
  }

  .map-sales-point {
    grid-area: map-sales-point;
  }
}

::-webkit-scrollbar {
  width: 0.5rem;

  height: 0.75rem;

}

::-webkit-scrollbar-thumb {
  background-color: #CAC5CB;

  border-radius: 20px;

}

::-webkit-scrollbar-thumb:hover {
  background-color: #79767B;
}
</style>